import { Dispatch } from 'redux'
import * as reservationsService from '../services/reservations'
import { ReservationItem } from '../reducers/reservationsReducer'

export const ACTIONS = {
  GET_RESERVATIONS_REQUEST: 'GET_RESERVATIONS_REQUEST',
  GET_RESERVATIONS_SUCCESS: 'GET_RESERVATIONS_SUCCESS',
  GET_RESERVATIONS_FAILURE: 'GET_RESERVATIONS_FAILURE',
  RELEASE_RESERVATION_REQUEST: 'RELEASE_RESERVATION_REQUEST',
  RELEASE_RESERVATION_SUCCESS: 'RELEASE_RESERVATION_SUCCESS',
  RELEASE_RESERVATION_FAILURE: 'RELEASE_RESERVATION_FAILURE',
  CREATE_RESERVATION_REQUEST: 'CREATE_RESERVATION_REQUEST',
  CREATE_RESERVATION_SUCCESS: 'CREATE_RESERVATION_SUCCESS',
  CREATE_RESERVATION_FAILURE: 'CREATE_RESERVATION_FAILURE',
  RESET_RESERVATIONS: 'RESET_RESERVATIONS',
} as const

const GET_RESERVATIONS_REQUEST = () => ({
  type: ACTIONS.GET_RESERVATIONS_REQUEST,
})

const GET_RESERVATIONS_SUCCESS = (items: ReservationItem[]) => ({
  type: ACTIONS.GET_RESERVATIONS_SUCCESS,
  items,
})

const GET_RESERVATIONS_FAILURE = (error: Error) => ({
  type: ACTIONS.GET_RESERVATIONS_FAILURE,
  error,
})

const RELEASE_RESERVATION_REQUEST = (id: number) => ({
  type: ACTIONS.RELEASE_RESERVATION_REQUEST,
  id,
})

const RELEASE_RESERVATION_SUCCESS = (id: number) => ({
  type: ACTIONS.RELEASE_RESERVATION_SUCCESS,
  id,
})

const RELEASE_RESERVATION_FAILURE = (error: Error, id: number) => ({
  type: ACTIONS.RELEASE_RESERVATION_FAILURE,
  error,
  id,
})

const CREATE_RESERVATION_REQUEST = () => ({
  type: ACTIONS.CREATE_RESERVATION_REQUEST,
})

const CREATE_RESERVATION_SUCCESS = (item: ReservationItem) => ({
  type: ACTIONS.CREATE_RESERVATION_SUCCESS,
  item,
})

const CREATE_RESERVATION_FAILURE = (error: Error) => ({
  type: ACTIONS.CREATE_RESERVATION_FAILURE,
  error,
})

const RESET_RESERVATIONS = () => ({
  type: ACTIONS.RESET_RESERVATIONS,
})

export const getReservations = () => {
  return (dispatch: Dispatch) => {
    dispatch(GET_RESERVATIONS_REQUEST())
    return reservationsService
      .getReservations()
      .then((items) => dispatch(GET_RESERVATIONS_SUCCESS(items)))
      .catch((error) => dispatch(GET_RESERVATIONS_FAILURE(error)))
  }
}

export const releaseReservation = (reservationId: number) => {
  return (dispatch: Dispatch) => {
    dispatch(RELEASE_RESERVATION_REQUEST(reservationId))
    return reservationsService
      .cancelReservation(reservationId)
      .then(() => dispatch(RELEASE_RESERVATION_SUCCESS(reservationId)))
      .catch((error) =>
        dispatch(RELEASE_RESERVATION_FAILURE(error, reservationId))
      )
  }
}

export const createReservation = (barcodeUid: string, locale: string) => {
  return (dispatch: Dispatch) => {
    dispatch(CREATE_RESERVATION_REQUEST())
    return reservationsService
      .createReservation(barcodeUid, locale)
      .then((item) => {
        dispatch(CREATE_RESERVATION_SUCCESS(item))
        return item
      })
      .catch((error) => {
        dispatch(CREATE_RESERVATION_FAILURE(error))
        throw error
      })
  }
}

export const resetReservations = () => {
  return (dispatch: Dispatch) => {
    dispatch(RESET_RESERVATIONS())
  }
}
